import { useMemo } from "react";

import { useBoards } from "Boards/BoardContext";

export const useHasSignupAdditionalNameRows = () => {
  const [{ rows }] = useBoards();

  return useMemo(() => {
    return rows.some((row) => row.entityType === "signupAdditionalName");
  }, [rows]);
};
